import type { Metric } from "web-vitals";

const THRESHOLDS: Record<string, [number, number]> = {
  CLS: [0.1, 0.25],
  FID: [100, 300],
  FCP: [1800, 3000],
  LCP: [2500, 4000],
  TTFB: [800, 1800],
};

type UmamiWindow = Window & {
  umami?: { track?: (event: string, data?: Record<string, unknown>) => void };
};

const rate = (name: string, value: number): string => {
  const bounds = THRESHOLDS[name];
  if (!bounds) return "unknown";
  return value <= bounds[0] ? "good" : value <= bounds[1] ? "needs-improvement" : "poor";
};

const send = (metric: Metric, isRetry: boolean): void => {
  if (localStorage.getItem("umami.disabled") === "1") return;
  const umami = (window as UmamiWindow).umami;
  if (!umami?.track) {
    if (!isRetry) setTimeout(() => send(metric, true), 5000);
    return;
  }
  umami.track(`vital-${metric.name}`, {
    value:
      metric.name === "CLS" ? Math.round(metric.value * 1000) / 1000 : Math.round(metric.value),
    rating: rate(metric.name, metric.value),
  });
};

const webVitalsToUmami = (metric: Metric): void => send(metric, false);

export default webVitalsToUmami;
